import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React, {useEffect, useState} from "react"

const handleHamburgerClick = (e) => {
  // toggle page scroll menu
  var body = document.body;
  body.classList.toggle("overlay-visible");

  // toggle the menu
  var menu = document.getElementById("menu");
  menu.classList.toggle("overlay-visible");

  // move the hamburger to cater for missing scrollbars
  var hamburger = document.getElementById("hamburger");
  hamburger.classList.toggle("overlay-visible");

  // overlay close button
  var overlayClose = document.getElementById("overlay-close");
  overlayClose.classList.toggle("overlay-visible");

  // let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
  // console.log(scrollbarWidth);

  // animate the burger icon
  if (menu.classList.contains("overlay-visible")) {
    // burger -> x
  }
  else {
    // x -> burger
  }
};

const handleOverlayCloseClick = (e) => {
  // toggle page scroll menu
  var body = document.body;
  body.classList.toggle("overlay-visible");

  // toggle the menu
  var menu = document.getElementById("menu");
  menu.classList.toggle("overlay-visible");

  // move the hamburger to cater for missing scrollbars
  var hamburger = document.getElementById("hamburger");
  hamburger.classList.toggle("overlay-visible");

  // overlay close button
  var overlayClose = document.getElementById("overlay-close");
  overlayClose.classList.toggle("overlay-visible");

  // let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
  // console.log(scrollbarWidth);

  // animate the burger icon
  if (menu.classList.contains("overlay-visible")) {
    // burger -> x
  }
  else {
    // x -> burger
  }
};

const HeaderHome = (props) => {

const [showScroll, setShowScroll] = useState(false)

useEffect(() => {
  // console.log('useEffect')

  // const homepageHeader = document.getElementById('homepage-hero-after')
  // const homepageHeaderAfter = document.getElementById('homepage-hero-after')
  // console.log(homepageHeader)
  // console.log(homepageHeader.pageYOffset)
  
  let offset = 720
  if (typeof window !== 'undefined') {
    offset = window.innerHeight * 1
  }

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > offset){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= offset){
      setShowScroll(false)
    }
  };

  // const scrollTop = () =>{
  //   if (showScroll) {
  //     window.scrollTo({top: 0, behavior: 'smooth'});
  //   }
  // };

  window.addEventListener('scroll', checkScrollTop)

    // document.getElementById('back-to-top').addEventListener('click', scrollTop)
  });

// console.log(props.forceFilterBtn);

  return (
  <>
  <div class="site-header-home-wrapper">
    <header class="site-header site-header-home site-header-overlay">
      <div class="grid-header">
        <div></div>
        <div class="site-logo">
          {/* <Link to="/"><img src="/images/placeholders/shift-logo-black.png" /></Link> */}
          {/* <Link to="/" className="shift-logo homepage-shift-logo"><img src="/images/shift-logo-omg-white.svg" /></Link> */}
          {/* <Link to="/" className="shift-logo homepage-shift-logo"><img src="/images/shift-logo-homepage.svg" /></Link> */}
          {/* <Link to="/" className="shift-logo homepage-shift-logo"><img src="/images/shift-logo-homepage.png" srcset="/images/shift-logo-homepage.png 1x, /images/shift-logo-homepage.svg 2x, /images/shift-logo-homepage.svg 3x" alt="SHIFT Active Media" /></Link> */}
          <Link to="/" className="shift-logo homepage-shift-logo"><img src="/images/shift-logo.png" x-srcset="/images/shift-logo-homepage.png 1x, /images/shift-logo-homepage.svg 2x, /images/shift-logo-homepage.svg 3x" alt="SHIFT Active Media" /></Link>
        </div>
        <div class="hamburger hamburger-over-header" id="hamburger" onClick={handleHamburgerClick} style={{filter: (showScroll && (typeof props.forceFilterBtn === 'undefined' || props.forceFilterBtn === false)) ? 'none' : 'invert(100%)'}}>
          {/* <img src="/images/hamburger-black.svg" alt="Menu" /> */}
          <img src="/images/hamburger-3-lines.svg" alt="Menu" />
        </div>
        <div class="overlay-close" id="overlay-close" onClick={handleOverlayCloseClick}>
          <img src="/images/overlay-close.svg" alt="Close menu" />
        </div>
      </div>
    </header>
    </div>
  </>
)}

export default HeaderHome
